import type { FaireProductEntity } from "../../entity_types/product";

export const p_7nmw5ya8su: FaireProductEntity = {
  token: "p_7nmw5ya8su",
  type: "product",
  name: "Women's Coastal Double Gauze Smocked Dress",
  brandToken: "b_951nzlloyx",
  brandName: "Pact",
  imageUrl:
    "https://cdn.faire.com/fastly/2fbef9a4e1dfa77d03c19d5dd29be2f471b80843b2a9a35a6ac59260c85b3272.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c2cb7908f8e20cd7a9644e28a1a44052ab98839d94e496c34b73fd6153d23981.jpeg",
    "https://cdn.faire.com/fastly/b1322729a77708dafed7a5d299e3c7a164619eb02a2f8ccc0a75ed95a60ab80b.jpeg",
    "https://cdn.faire.com/fastly/ce70bb5d0f69f3de6d89673c07020f04e5dabac01c677df2a1f8351f9e6143a5.jpeg",
    "https://cdn.faire.com/fastly/09fc12ffc2df99f0f03be1e977ff593229dfacb1b13242d8c231cfcba61cd122.jpeg",
    "https://cdn.faire.com/fastly/accd0c7708a0a32c2bb9b40c0fba5cb41b736e4eb568c1dccd5414fc3fc64ab1.jpeg",
    "https://cdn.faire.com/fastly/518b76daabdd4f4fde6c78f27ec9a634514e87e86caf0c69061948bd54caeda9.jpeg",
    "https://cdn.faire.com/fastly/54495ebf5986362a6f6dd2e8fa6a1f0ecbd5ff721bda79b0340a3b1bf9ec4156.jpeg",
    "https://cdn.faire.com/fastly/d5c503aa72d2fe8375864988d0582b25f915fd3becbc9a0a100bc6026284a69d.jpeg",
    "https://cdn.faire.com/fastly/758d0f6216ef63060e759f2245fa573226247ba1c360d5966990a8b6f60e6345.jpeg",
    "https://cdn.faire.com/fastly/c5abe8158205e4308197dcdbfe0a72558cae0167217e632089780dd80301ead0.jpeg",
    "https://cdn.faire.com/fastly/31f86e047bf60b6bdc2f4e42d2aa94efee5da4110764d39452233b81479b6133.jpeg",
    "https://cdn.faire.com/fastly/d292d6d3bc0d1f230228445d9dd106c5c3a63618832c6c10c909be246c49a8e7.jpeg",
    "https://cdn.faire.com/fastly/8f833f658bb5944c18cbb63a74c6b57c5901dc07a8e1cd41ee124b7e6f52a97e.jpeg",
    "https://cdn.faire.com/fastly/5c9deec935d922c27b2f0c91ae6c3fa392088e4cbf57a6cc922cd48f41164864.jpeg",
    "https://cdn.faire.com/fastly/9d6db2b8d5f16d36fd6a6cc1f23839b9cb7bfb243c57f3cec808e73c6dbef634.jpeg",
    "https://cdn.faire.com/fastly/1e73792dfc18f1c7e37e23a2f37035ddeba3d16364353551265bfb7ff9ec0259.jpeg",
    "https://cdn.faire.com/fastly/844685c10005e494af81e583fe9fa9724de03310e303b39dfc015b27af87b66a.jpeg",
    "https://cdn.faire.com/fastly/886ed9d526a0dd4c03019401d741805c8ca4b932c92d824c98abde4666ad7443.jpeg",
    "https://cdn.faire.com/fastly/4d486ac1e7de2d4da1d2e46d5537a3e275ef597244a7bf19034502be41e4053e.jpeg",
  ],
  priceDollars: 49,
  description:
    'Elastic smocked bodice, elastic finish around neckline and armholes. Crew neck, bra-friendly. Hidden on-seam pockets. Midi length, hits mid-calf on most. Due to the nature of the fabric, there can be slight differences in coloration, and some colors may appear lighter than pictured. Midi length. Front Length, Size M: 51.25". GOTS Organic Certified by Control Union 832196 .Machine wash cold. Line dry, do not dry clean.',
  tags: [],
  msrpDollars: 98,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:03.835Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
